import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '@/components/nav/Sidebar'
import Topbar from '@/components/nav/Topbar'
import { useSidebarStore } from '@/stores/useSidebarStore'
import { cn } from '@/utils/cn'

export default function DashboardLayout() {
  const { isOpen, setMobile } = useSidebarStore()

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1024
      setMobile(isMobile)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [setMobile])

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      
      <div className={cn(
        'flex flex-col transition-all duration-200 ease-in-out lg:ml-64',
        !isOpen && 'lg:ml-16'
      )}>
        <Topbar />
        
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}